// extracted by mini-css-extract-plugin
module.exports = {"section":"d_f","emphasis":"d_g"};